import React, { createContext, useReducer, Dispatch } from 'react';
import { IServiceStatusAction } from './action';
import { IServiceStatusState } from './state';
import serviceStatusReducer, { defaultState, IServiceStatusReducer } from './reducer';

export const ServiceStatusState = createContext<IServiceStatusState>(defaultState);
export const ServiceStatusAction = createContext<Dispatch<IServiceStatusAction>>(() => {});

interface Props {
    children: React.ReactElement;
}

function ServiceStatusProvider({ children }: Props) {
    const [states, dispatcher] = useReducer<IServiceStatusReducer>(serviceStatusReducer, defaultState);

    return (
        <ServiceStatusAction.Provider value={dispatcher}>
            <ServiceStatusState.Provider value={states}>{children}</ServiceStatusState.Provider>
        </ServiceStatusAction.Provider>
    );
}

export default ServiceStatusProvider;
